// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pCkk","newExpiryDate":"styles_newExpiryDate__xQHc4","footer":"styles_footer__1l_XI"};